package com.nonopn.skywatcher.design.appbar

import androidx.compose.runtime.Composable
import com.nonopn.skywatcher.design.utils.localized
import com.nonopn.skywatcher.design.widgets.MenuItem
import org.jetbrains.compose.resources.StringResource

sealed class AppBarState(
    val actions: List<MenuItem>? = null
) {
    @Composable
    abstract fun showTitle(): String

    open suspend fun translateTitle(): StringResource? = null

    data object Hidden : AppBarState(null) {
        @Composable
        override fun showTitle() = "hidden"
    }

    class Regular(
        val title: String = "",
        actions: List<MenuItem>? = null
    ) : AppBarState(actions) {
        @Composable
        override fun showTitle() = title
    }

    class Localized(
        val title: StringResource,
        actions: List<MenuItem>? = null
    ) : AppBarState(actions) {
        @Composable
        override fun showTitle() = title.localized()
    }
}
